import React from "react";
import { Col, Row, Container } from "react-bootstrap";
import "./OfficeAddress.css";
const OfficeAddress = props => {
  return (
    <div className="officeDetail">
     <Container >
     <Row >
        {props.heading.map((location, index) => {
          return (
            <Col className = "detail first-detail first-col" key={index} sm={4} >
              <h6>{location.city}</h6>
              {location.info.map((information, index) => {
                return (
                  <p key={index} >
                    {information}
                  </p>
                );
              })}
            </Col>
          );
        })}
      </Row>
     </Container>
    </div>
  );
};

export default OfficeAddress;
